import { Link } from "@tanstack/react-router";
import { useUnread } from "../lib/push";
import { BellIcon } from "./Icons";
import { notifications } from "@pagemates/shared/copy";

const txt = notifications.bell;

const shown = (n: number) => (n > 99 ? "99+" : String(n));

/** The inbox bell with its unread count. `nav` is the sidebar's row. */
export function Bell({ nav }: { nav?: boolean }) {
  const n = useUnread();
  const label = n ? txt.inboxUnread(n) : txt.inbox;
  if (nav) {
    return (
      <Link to="/inbox" className="nav quiet bell-nav" aria-label={label}>
        <BellIcon />{txt.inbox}{n > 0 && <span className="cs-new" aria-hidden="true">{shown(n)}</span>}
      </Link>
    );
  }
  return (
    <Link to="/inbox" className="bell" aria-label={label}>
      <BellIcon />{n > 0 && <span className="bell-n" aria-hidden="true">{shown(n)}</span>}
    </Link>
  );
}
